import { render, staticRenderFns } from "./Archive.vue?vue&type=template&id=6d8f6068&scoped=true"
import script from "./Archive.vue?vue&type=script&lang=ts"
export * from "./Archive.vue?vue&type=script&lang=ts"
import style0 from "./Archive.vue?vue&type=style&index=0&id=6d8f6068&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d8f6068",
  null
  
)

export default component.exports